import {RefreshControl, StyleSheet, View} from "react-native";
import {ReactNode, useCallback, useMemo, useState} from "react";
import {Color} from "@/lib/styles";
import {useQueryClient} from "@tanstack/react-query";
import {KeyboardAwareScrollView} from "react-native-keyboard-controller";

type Props = {
    children: ReactNode,
    scrollable?: boolean,
}

// Outer wrapper container for all pages.
export default function Page({scrollable, children}: Props) {
    const [refreshing, setRefreshing] = useState(false);
    const queryClient = useQueryClient();

    const onRefresh = useCallback(async () => {
        setRefreshing(true);
        await queryClient.invalidateQueries();
        setRefreshing(false);
    }, [queryClient])

    const innerView = useMemo(() => {
        return (
            <View style={styles.expandingBox}>
                <View style={styles.innerView}>
                    {children}
                </View>
            </View>
        )
    }, [children]);

    const refreshControl = useMemo(() => {
        return (
            <RefreshControl refreshing={refreshing}
                            onRefresh={onRefresh}
                            tintColor={Color.PrimaryText}
                            title={"Dra for å oppfriske"}
                            titleColor={Color.PrimaryText}
                            colors={[Color.PrimaryText]}
            />
        )
    }, [refreshing, onRefresh]);

    if (scrollable) {
        return (
            <View style={[styles.outer]}>
                <KeyboardAwareScrollView
                    focusable={false}
                    indicatorStyle={"white"}
                    persistentScrollbar={false}
                    refreshControl={refreshControl}
                    contentInsetAdjustmentBehavior={"always"}
                >
                    {innerView}
                </KeyboardAwareScrollView>
            </View>
        )
    }

    return (
        <View style={styles.outer}>
            {innerView}
        </View>
    );
}

export const styles = StyleSheet.create({
    outer: {
        flex: 1,
        backgroundColor: Color.Background,
    },
    expandingBox: {
        flex: 1,
        gap: 8,
        width: "100%",
        maxWidth: 664,
        marginHorizontal: "auto",
    },
    innerView: {
        flex: 1,
        flexDirection: "column",
        margin: 8,
        //marginBottom: 8,
        gap: 8,
    },
});